import { render } from "./Ranking.vue?vue&type=template&id=a860d58c&scoped=true&ts=true"
import script from "./Ranking.vue?vue&type=script&lang=ts"
export * from "./Ranking.vue?vue&type=script&lang=ts"

import "./Ranking.vue?vue&type=style&index=0&id=a860d58c&scoped=true&lang=scss"

import exportComponent from "/Users/icer/Works/2105-chia/_cns/ChiaNameServiceSite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a860d58c"]])

export default __exports__